import { $IsStateFilter } from 'angular-ui-router/lib/stateFilters';
import { LoggedUser } from '../../../redux/store';
import { loginModule } from '../login-module';

loginModule.factory('LinkActionsService', ['$ngRedux', '$transitions', '$window', '$state', 'dialogs', '$translate', function ($ngRedux, $transitions, $window, $state, dialogs, $translate) {

    let state: {
        loggedUser: LoggedUser,
    } = { loggedUser: null };


    let executeAction = (action, params) => {
        $ngRedux.connect(state => ({ loggedUser: state.loggedUser }))(state);

        switch (action) {
            case 'order-create':
                //@TODO verificar se o user pode lançar pedido
                if (state.loggedUser?.email == params.email) {
                    return ['create-new-order', { storeId: params.shop }];
                } else {
                    dialogs.alert($translate.instant('LGIN_WITH_EMAIL',{email: params.email}))

                    if (!state.loggedUser){
                        $window.location.href = `login.html#/?email=${params.email}`
                    }
                }
        }

        return [ false, false ];
    }


    return {
        subscribe: function(){
            $transitions.onBefore({ to: 'actions' }, function (transition) {
                const params = transition.params();
                const action = params.action;

                const [ newState, newParams ] = executeAction(action, params)
                if (newState){
                    return transition.router.stateService.target(newState, newParams);
                }
            });

            document.addEventListener('deviceready', function () {
                (<any>window).universalLinks.subscribe(null, function (data) {

                    if (data.hash.indexOf('/actions/') == 0){
                        const paramsIndex = data.hash.indexOf('?');

                        const search = paramsIndex > -1 ? data.hash.slice(data.hash.indexOf('?')+1) : undefined;
                        const action = data.hash.slice(9 ,paramsIndex > -1 ? data.hash.indexOf('?') : undefined);
                        const params = search ? JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : {};

                        const [ newState, newParams ] = executeAction(action, params);
                        if (newState){
                            return $state.go(newState, newParams);
                        }
                    }
                });
            }, false);
        }
    }
}])